
import Pagination from './Pagination'


Vue.component(Pagination.name, Pagination)